"use strict";

exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/helpers/objectWithoutProperties.js
 ** module id = 265
 ** module chunks = 0
 **/